import { Box, Button, FormControl, FormControlLabel, Link, List, ListItem, ListItemText, Radio, RadioGroup, TextField, Typography, useTheme } from '@mui/material';
import sizeFontCustom from "../Discovery/fontSize.styles"
import styles from './NoAccountContainer.styles';
import { useState } from 'react';
import { isPhoneNumberValid } from '../../hepler/functions';
import { useTranslation } from '../../hooks/useTranslation';
import BackIconButton from '../common/BackIconButton';
import { PAGE_HEADING_ID } from '../../utils/pageHeading.utils';
import { handleOtpPaste } from '../../utils/a11y.utils';

function EmbededChangeNumber(props) {
  const { t } = useTranslation();
  const { setSuperState, superState,  handleOTPChange, sendOtp, verifyOtp, handleToggleNumber } = props
  const theme = useTheme();
  const [phoneNumberAlternate, setPhoneNumberAlternate] = useState('');
  const [changeNumber, setChangeNumber] = useState("other")
  const [isPhoneInValid, setIsPhoneInValid] = useState(false)
  const handleChange = (event) => {
    setChangeNumber(event.target.value);
  };
  const handleBackArrow = () => {
    props?.setChangingMobileNumber(false)
    props?.setShowChangeNumber(false)
  }
  const handleSubmit = async () => {
    if (superState.noAccount === 101) {
      if (changeNumber === "other") {
        if(isPhoneNumberValid(phoneNumberAlternate)){
          await setSuperState(phoneNumberAlternate, null)
          sendOtp()
        }else{
          setIsPhoneInValid(false)
        }
      } else {
        handleToggleNumber(changeNumber)
      }

    } else if (superState.noAccount === 102) {
      verifyOtp()
    } else {
      await setSuperState(null, 101)
    }
  }
  return (
    <List disablePadding>
      <ListItem disablePadding>
        <ListItemText
          sx={{
            "& .MuiListItemText-primary": { color: theme.palette.info.main, fontWeight: 900, mb: "0.75rem" },
            "& .MuiListItemText-secondary": { color: theme.palette.black60, ...sizeFontCustom.subHeading },
            marginBottom: "1.5rem"
          }}
          primary={
            <Box
              sx={styles.heading}>
              {global.isAddAccount &&
                <BackIconButton
                  sx={{ ml: '-10px', mr: '0.25rem' }}
                  iconSx={{ color: props.customDetails.primaryColor, fontSize: "1.25rem" }}
                  onClick={handleBackArrow}
                />
              }
              <Typography
                id={PAGE_HEADING_ID}
                component="h1"
                sx={styles.changeNumberText}
              >
                {t('common.buttons.changeMobileNumberSmall')}
              </Typography>

            </Box>

          }
          secondary={
            <>
              {
                superState.noAccount === 102 ?
                  `OTP sent to ${phoneNumberAlternate}`
                  : (superState.noAccount === 101 ?
                    <>
                    {t('accountDiscovery.changeMobileNumber.selectAlreadyVerified')}
                      <FormControl sx={{ display: "block" }}>
                        <RadioGroup
                          aria-labelledby={PAGE_HEADING_ID}
                          name="controlled-radio-buttons-group"
                          value={changeNumber}
                          onChange={handleChange}

                        >
                          {global.mobileNumberArray.map((el, i) => 
                            <FormControlLabel 
                              key={el} 
                              value={el} 
                              control={<Radio size='small' />} 
                              label={<Typography sx={sizeFontCustom.subHeading}>{el}</Typography>} 
                            />
                          )}
                          <FormControlLabel 
                            sx={sizeFontCustom.subHeading} 
                            value="other" 
                            control={<Radio size='small' />} 
                            label={<Typography sx={sizeFontCustom.subHeading}>{t('accountDiscovery.messages.addNewNumber')}</Typography>} 
                          />
                        </RadioGroup>
                      </FormControl>
                    </>
                    : <>
                      {t('accountDiscovery.changeMobileNumber.noDiscoveredAccounts')} {" "}
                      <strong>{props.match.params?.number}</strong></>
                  )
              }

            </>
          }
        />
      </ListItem>
      <>
        {
          superState.noAccount === 101 && changeNumber === "other" ?
            <ListItem disablePadding>
              <TextField
                name="tel"
                variant='outlined'
                type='tel'
                size='small'
                label={<Typography sx={sizeFontCustom.heading}>{t('accountDiscovery.changeMobileNumber.enterPhoneNumber')}</Typography>}
                autoComplete="tel"
                inputProps={{ style: { fontSize: "0.875rem" }, autoComplete: 'tel', inputMode: 'numeric' }}
                value={phoneNumberAlternate}
                onChange={(e) => setPhoneNumberAlternate(e.target.value)}
                fullWidth
                error={isPhoneInValid}
                helperText={isPhoneInValid ? t('common.messages.validPhoneNumber') : ''}
                FormHelperTextProps={{ role: 'alert' }}
                sx={{ mb: "1rem" }}
              />
            </ListItem>
            :
            (superState.noAccount === 102 ?
              <>
                <TextField
                  name="otp"
                  fullWidth
                  size='small'
                  label={t('common.labels.enterOtp')}
                  autoComplete="one-time-code"
                  inputProps={{ autoComplete: 'one-time-code', inputMode: 'numeric' }}
                  value={superState.OTP}
                  onChange={handleOTPChange}
                  onPaste={handleOtpPaste((value) => {
                    handleOTPChange({ target: { value } });
                  }, 6)}
                  sx={{ mb: "1.25rem" }}
                />
                {!superState.isResend
                  ?
                  <Typography
                    sx={styles.resendText}>
                    {t('accountDiscovery.changeMobileNumber.resentOtp')}
                    <strong
                      style={{
                        color: theme.palette.error.main,
                      }}>
                      {" " + superState.time} sec
                    </strong>
                  </Typography>
                  :
                  <Link
                    component="button"
                    type="button"
                    display={"flex"}
                    underline='none'
                    disabled={!superState.isResend}
                    onClick={sendOtp}
                    sx={{
                      ...sizeFontCustom.subHeading,
                      cursor: "pointer",
                      m: "0 0 0.875rem 0",
                      color: `${(superState.isResend) ? theme.palette.primary.main : 'grey'}`,
                      background: 'none',
                      border: 'none',
                      padding: 0,
                      font: 'inherit',
                    }}
                  >
                    {t('common.buttons.resendOtp')}
                  </Link>
                }
              </>
              : null
            )
        }
      </>
      <ListItem disablePadding>
        <Button
          variant='contained'
          fullWidth
          disabled={superState.noAccount === 101 ? changeNumber === "other" ? phoneNumberAlternate.length !== 10 : false : superState.noAccount === 102 ? superState.OTP.length < 6 : false}
          onClick={handleSubmit}
          sx={{
            textTransform: "capitalize",
            ...sizeFontCustom.subHeading
          }}
        >
          {t('common.buttons.continue')}
        </Button>
      </ListItem>
    </List>

  )
}

export default EmbededChangeNumber